import React from "react";

const FloatingDecorations = () => {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Top left - Pizza slice */}
      <div
        className="absolute top-10 left-5 animate-float opacity-50"
        style={{ animationDelay: "0s" }}
      >
        <div className="text-6xl md:text-8xl transform rotate-12">🍕</div>
      </div>

      {/* Top right - Burger */}
      <div
        className="absolute top-20 right-10 animate-float opacity-40"
        style={{ animationDelay: "1s" }}
      >
        <div className="text-5xl md:text-7xl transform -rotate-12">🍔</div>
      </div>

      {/* Middle left - Taco */}
      <div
        className="absolute top-1/4 left-10 animate-float opacity-50"
        style={{ animationDelay: "2s" }}
      >
        <div className="text-7xl md:text-9xl transform rotate-6">🌮</div>
      </div>

      {/* Middle right - Sushi */}
      <div
        className="absolute top-1/3 right-5 animate-float opacity-45"
        style={{ animationDelay: "1.5s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-6">🍱</div>
      </div>

      {/* Bottom left - Noodles */}
      <div
        className="absolute bottom-1/4 left-20 animate-float opacity-50"
        style={{ animationDelay: "0.5s" }}
      >
        <div className="text-5xl md:text-7xl transform rotate-12">🍜</div>
      </div>

      {/* Bottom right - Ice cream */}
      <div
        className="absolute bottom-20 right-16 animate-float opacity-40"
        style={{ animationDelay: "2.5s" }}
      >
        <div className="text-6xl md:text-8xl transform -rotate-12">🍦</div>
      </div>

      {/* Floating leaves */}
      <div
        className="absolute top-40 left-1/4 animate-leaf opacity-55"
        style={{ animationDelay: "0s" }}
      >
        <div className="text-3xl md:text-4xl transform rotate-45">🍃</div>
      </div>

      <div
        className="absolute top-60 right-1/3 animate-leaf opacity-60"
        style={{ animationDelay: "1s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-30">🍃</div>
      </div>

      <div
        className="absolute bottom-40 left-1/3 animate-leaf opacity-50"
        style={{ animationDelay: "2s" }}
      >
        <div className="text-4xl md:text-5xl transform rotate-60">🍃</div>
      </div>

      <div
        className="absolute bottom-60 right-1/4 animate-leaf opacity-55"
        style={{ animationDelay: "1.5s" }}
      >
        <div className="text-3xl md:text-4xl transform -rotate-45">🍃</div>
      </div>

      {/* Connected leaf clusters - Top right vine */}
      <div
        className="absolute top-32 right-20 animate-leaf opacity-50"
        style={{ animationDelay: "0.3s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-20">🍃</div>
      </div>
      <div
        className="absolute top-36 right-16 animate-leaf opacity-55"
        style={{ animationDelay: "0.5s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-15">🍃</div>
      </div>
      <div
        className="absolute top-40 right-12 animate-leaf opacity-60"
        style={{ animationDelay: "0.7s" }}
      >
        <div className="text-3xl md:text-4xl transform rotate-10">🍃</div>
      </div>

      {/* Connected leaf clusters - Left side vine */}
      <div
        className="absolute top-52 left-8 animate-leaf opacity-50"
        style={{ animationDelay: "1.2s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-25">🍃</div>
      </div>
      <div
        className="absolute top-56 left-12 animate-leaf opacity-55"
        style={{ animationDelay: "1.4s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-20">🍃</div>
      </div>
      <div
        className="absolute top-60 left-16 animate-leaf opacity-60"
        style={{ animationDelay: "1.6s" }}
      >
        <div className="text-3xl md:text-4xl transform -rotate-15">🍃</div>
      </div>

      {/* Connected leaf clusters - Bottom left vine */}
      <div
        className="absolute bottom-52 left-24 animate-leaf opacity-50"
        style={{ animationDelay: "2.2s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-35">🍃</div>
      </div>
      <div
        className="absolute bottom-48 left-28 animate-leaf opacity-55"
        style={{ animationDelay: "2.4s" }}
      >
        <div className="text-2xl md:text-3xl transform rotate-40">🍃</div>
      </div>
      <div
        className="absolute bottom-44 left-32 animate-leaf opacity-60"
        style={{ animationDelay: "2.6s" }}
      >
        <div className="text-3xl md:text-4xl transform rotate-45">🍃</div>
      </div>

      {/* Connected leaf clusters - Bottom right vine */}
      <div
        className="absolute bottom-72 right-28 animate-leaf opacity-50"
        style={{ animationDelay: "1.8s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-35">🍃</div>
      </div>
      <div
        className="absolute bottom-68 right-24 animate-leaf opacity-55"
        style={{ animationDelay: "2.0s" }}
      >
        <div className="text-2xl md:text-3xl transform -rotate-40">🍃</div>
      </div>
      <div
        className="absolute bottom-64 right-20 animate-leaf opacity-60"
        style={{ animationDelay: "2.2s" }}
      >
        <div className="text-3xl md:text-4xl transform -rotate-45">🍃</div>
      </div>
    </div>
  );
};

export default FloatingDecorations;
